// removed by extract-text-webpack-plugin
module.exports = {"container":"_155SR9j0NaPNGGyzjYEucn"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/PlanModal/components/ErrorView/styles.scss
// module id = 631
// module chunks = 11